import * as Yup from "yup";
import { useFormik } from "formik";
import { StatusCodes } from "http-status-codes";
import React, { useState } from "react";

import {Checkbox,Autocomplete, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import { TestKitCodeTextField } from "./TestKitCodeTextField";
import { NextButton } from "../../common/NextButton";
import { useMessageProvider } from "../../common/message-provider";
import { usePartnerAxios } from "../../common/partner-axios";


type KitRegistrationModel = {
  testKitCode: string;
  firstName: string;
  lastName: string;
  email: string;
  clinicemail: string;
  gender: string;
  yearOfBirth: number | null;
};

export type GuestUserDto = {
  displayName: string;
  subject: string;
  userId: number;
};


const maxDisplayYears = 100;

type KitRegistrationPageProps = {
  onSuccess: (testKitCode: string, userId: number) => void;
};

export const KitRegistrationPage = ({ onSuccess }: KitRegistrationPageProps) => {
  const partnerAxios = usePartnerAxios();
  const messageProvider = useMessageProvider();
  const [testKitCodeStatus, setTestKitCodeStatus] = useState(StatusCodes.OK);
  const [isSaving, setIsSaving] = useState(false);
  const [isHide, setisHide] = useState(false);
  const [isRequired, setisRequired] = useState(false);
  const [ischecked, setChecked] = useState(false);
  const [isFrench,setIsFrench]=useState(false);
  const [inputFieldLabel,setLabelsLabels]=useState({
    labelFirstName: "First Name",
    labelLastName: "Last Name",
    labelEmail:"Email",
    clinicEmail:"Clinic Email",
    labelKitCode:"Test Kit Code",
    labelGender: "Gender",
    labelBirthYear:"Year of Birth"

  })
  
  const genderList = ["Male", "Female", "Prefer not to disclose"];
 
  const handleChange = () => { 
    
    setChecked(!ischecked); 
    if(!ischecked){
      setisRequired(true)
    }else{
      setisRequired(false)
    }
    
    
  }; 
  const getBirthYearList = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: maxDisplayYears }, (_v, i) => currentYear - (maxDisplayYears - 1 - i));
  };

  const formik = useFormik({
    initialValues: {
      testKitCode: "",
      firstName: "",
      lastName: "",
      email: "",
      clinicemail: "",
      gender: "",
      yearOfBirth: null,
    } as KitRegistrationModel,
    validationSchema: Yup.object().shape({
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string().required("Email is required").email("Email is invalid"),
      clinicemail: isRequired==true? Yup.string().required("Email is required").email("Email is invalid"):Yup.string(),
      gender: Yup.string().required("Gender is required"),
      yearOfBirth: Yup.number().nullable().required("Year of Birth is required"),
      testKitCode: Yup.string()
        .required("Test Kit Code is required")
        .test({
          name: "exist",
          test: () => testKitCodeStatus !== StatusCodes.NOT_FOUND,
          message: "Test Kit Code does not exist",
        })
        .test({
          name: "checkable",
          test: () => testKitCodeStatus === StatusCodes.OK,
          message: "Could not check test kit code existence",
        }),
    }),
    onSubmit: async (model: KitRegistrationModel) => {
      try {
        setIsSaving(true);
        const resp = await partnerAxios.post("iam/users/me", model);
        console.log("check response",resp.data)
        const userDto: GuestUserDto = resp.data;
        onSuccess(model.testKitCode, userDto.userId);
      } catch {
        messageProvider.showError("Something went wrong. Please try again.");
      } finally {
        setIsSaving(false);
      }
    },
  });

  const handleOnTestKitCodeValidate = (status: StatusCodes,resp:"") => {
    setTestKitCodeStatus(status);
    
    if (status !== StatusCodes.OK) {
      formik.setFieldTouched("testKitCode");
    }else{
      
      if(resp.toString()=="dakota-rpt"){
        setisHide(true)
      }else{
        setisHide(false)
      }
    }

    formik.validateForm();
  };
  const switchLanguage=()=>{
    if(isFrench==false)
    {
      setIsFrench(true)
      setLabelsLabels({...inputFieldLabel,
        labelFirstName: "Prénom",
        labelLastName: "Nom de Famille",
        labelEmail:"Email",
        clinicEmail:"Clinique Email",
        labelKitCode:"Code du Test Kit",
        labelGender: "Sexe",
        labelBirthYear:"Date de Naissance"
      })
    
    }
    else
    {
      setIsFrench(false)
      setLabelsLabels({...inputFieldLabel,
        labelFirstName: "First Name",
        labelLastName: "Last Name",
        labelEmail:"Email",
        clinicEmail:"Clinic Email",
        labelKitCode:"Test Kit Code",
        labelGender: "Gender",
        labelBirthYear:"Year of Birth"
      })
    }
   
  }

  return (
    <form onSubmit={formik.handleSubmit}>
     
  <label className="switch">
	<input className="switch-input" type="checkbox" onChange={()=>switchLanguage()} />
	<span className="switch-label" data-on="English" data-off="français"></span> 
	<span className="switch-handle"></span> 
</label>


      <TextField
        name="firstName"
        value={formik.values.firstName}
        onChange={formik.handleChange}
        error={formik.touched.firstName && Boolean(formik.errors.firstName)}
        label={inputFieldLabel.labelFirstName}
        fullWidth
        size="small"
        helperText={formik.touched.firstName ? formik.errors.firstName : ""}
        sx={{ marginBottom: 3 }}
      />
      <TextField
        name="lastName"
        value={formik.values.lastName}
        onChange={formik.handleChange}
        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
        label={inputFieldLabel.labelLastName}
        fullWidth
        size="small"
        helperText={formik.touched.lastName ? formik.errors.lastName : ""}
        sx={{ marginBottom: 3 }}
      />
      <TextField
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        error={formik.touched.email && Boolean(formik.errors.email)}
        label={inputFieldLabel.labelEmail}
        fullWidth
        size="small"
        helperText={formik.touched.email ? formik.errors.email : ""}
        sx={{ marginBottom: 3 }}
      />
      
      <TestKitCodeTextField
        name="testKitCode"
        value={formik.values.testKitCode}
        onChange={formik.handleChange}
        error={formik.touched.testKitCode && Boolean(formik.errors.testKitCode)}
        label={inputFieldLabel.labelKitCode}
        fullWidth
        size="small"
        helperText={formik.touched.testKitCode ? formik.errors.testKitCode : ""}
        sx={{ marginBottom: 3 }}
        onValidate={handleOnTestKitCodeValidate}
      />
      
      
      
      
      <FormControl error={formik.touched.gender && Boolean(formik.errors.gender)} fullWidth sx={{ marginBottom: 3 }}>
        <InputLabel id="gender-label" size="small">
          {inputFieldLabel.labelGender}
        </InputLabel>
        <Select name="gender" value={formik.values.gender} onChange={formik.handleChange} labelId="gender-label" label="Gender" size="small">
          {
          isFrench?
          genderList.map((s, i) => (
            <MenuItem key={i} value={s}>
              {
              s=="Male"&&"Homme"
              }
              {
              s=="Female"&&"Femme"
              }
              {
                s=="Prefer not to disclose"&& "Je ne préfère pas répondre"
              }

            </MenuItem>
          )):
          genderList.map((s, i) => (
            <MenuItem key={i} value={s}>
              {s}
            </MenuItem>
          ))
          }
       
          
        </Select>
        <FormHelperText>{formik.touched.gender ? formik.errors.gender : ""}</FormHelperText>
      </FormControl>
      <Autocomplete
        renderOption={(props, option) => {
          return (
            <li {...props} key={option}>
              {option}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="yearOfBirth"
            value={formik.values.yearOfBirth}
            error={formik.touched.yearOfBirth && Boolean(formik.errors.yearOfBirth)}
            label={inputFieldLabel.labelBirthYear}
          
            helperText={formik.touched.yearOfBirth ? formik.errors.yearOfBirth : ""}
            size="small"
          />
        )}
        sx={{ marginBottom: 3 }}
        options={getBirthYearList()}
        getOptionLabel={(option) => option.toString()}
        onChange={(_, value: number | null) => {
          formik.setFieldValue("yearOfBirth", value);
        }}
      />
      {isHide==true?
      <>
      <Checkbox 
      
      onChange={handleChange}
      
      ></Checkbox> <span>
      I consent to share my skin health report with my clinic
      </span></>:null}

      {ischecked==true?
      <>
                
      <TextField
        name="clinicemail"
        value={formik.values.clinicemail}
        onChange={formik.handleChange}
        disabled={false}
        
        error={formik.touched.clinicemail && Boolean(formik.errors.clinicemail)}
        label={inputFieldLabel.clinicEmail}
        fullWidth
        size="small"
        helperText={formik.touched.clinicemail ? formik.errors.clinicemail : ""}
        sx={{ marginBottom: 3 }}
        placeholder="Enter Clinic Email"
        id="clinicemailId"
      />
      </>:null}

      <NextButton loading={isSaving} isFrenchLanguage={isFrench} sx={{ float: "right", marginTop: 3 }} />
    </form>
  );
};
